// extracted by mini-css-extract-plugin
export default {"list":"List_list__+AjdR","title":"List_title__jFa2e","nav":"List_nav__Xv5ez","link":"List_link__X1PdH","active":"List_active__Y8WTM","wrapper":"List_wrapper__yv2Ka"};